export enum EAdvertisementStatus {
  ACTIVE = 'ACTIVE',
  MODERATION = 'MODERATION',
  REJECTED = 'REJECTED',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
}

export enum EAdvertisementCategorySlug {
  GOODS = 'GOODS',
  SERVICES = 'SERVICES',
}

export interface IAdvertisementCategory {
  id: number;
  title: string;
  slug: string;
}

export interface ICompany {
  id: string;
  name: string;
  city: string;
  country: string;
}

export interface ICurrency {
  id: number;
  alias: string;
  letter: string;
}

export interface IPublicAdvertisementMetrics {
  views: number;
}

export interface IMyAdvertisementMetrics {
  views: number;
  request_contact: number;
}

export type TAdvertisementMetrics =
  | IPublicAdvertisementMetrics
  | IMyAdvertisementMetrics;

export interface IAdvertisementBase {
  id: string;
  title: string;
  description: string;
  category: IAdvertisementCategory;
  company: ICompany;
  images: string[];
  price: number;
  currency: ICurrency;
  metrics: TAdvertisementMetrics;
  published_at?: string | null;
}

export interface AdvertisementItemPublic extends IAdvertisementBase {
  __typename: 'PublicAdvertisement';
}

export interface ModerationInfo {
  date: string;
  comment?: string | null;
}

export interface IMyAdvertisement extends IAdvertisementBase {
  __typename: 'MyAdvertisement';

  status: EAdvertisementStatus;
  moderation?: ModerationInfo | null;
  contact: string;

  expires_at?: string | null;
  completed_at?: string | null;
}

export type TAdvertisementItem = AdvertisementItemPublic | IMyAdvertisement;

export interface IPartnerItem {
  id: number;
  title: string;
  description?: string | null;
  target_url: string;
  image: string;
  metadata?: string | null;
}

export interface IPaginatorInfo {
  currentPage: number;
  lastPage: number;
  hasMorePages: boolean;
  perPage: number;
  total: number;
}

export interface IAdvertisementList {
  paginatorInfo: IPaginatorInfo;
  data: TAdvertisementItem[];
}

export interface IAdvertisementFeed {
  advertisements: IAdvertisementList;
  partners: IPartnerItem[];
}
